<ng-template #cdkMenuTpl>
  <div @slideMotion class="dropdown-menu" cdkMenu>
    <ng-container *ngIf="availableItems$ | async; let items">
      @if (trigger !== DropdownTrigger_Context) {
        <span cdkMenuItem></span>
      }
      <div class="flex flex-col" [tabindex]="trigger !== DropdownTrigger_Context ? 0 : undefined">
        <ng-container *ngFor="let item of items">
          <ng-container
            *ngIf="item.isVisibleFn?.() ?? true"
            [ngTemplateOutlet]="
              (item | isDropdownHelpTextItem)
                ? buttonItemTpl
                : (item | isDropdownRouterLinkItem)
                  ? anchorItemTpl
                  : buttonItemTpl
            "
          ></ng-container>
          <ng-template #buttonItemTpl>
            <ng-template [ngIf]="(item | asDropdownDelimiterItemPipe).isDelimiter" [ngIfElse]="buttonTpl">
              <hr class="m-0" />
            </ng-template>

            <ng-template #buttonTpl>
              <ng-container *ngIf="item | isDropdownNestedItem; else actionItemTpl">
                <loop-dropdown-menu-renderer
                  #dropdownMenuRendererTpl
                  [availableItems]="(item | asDropdownNestedItem).childItems"
                  [triggerNested]="trigger"
                ></loop-dropdown-menu-renderer>
                <a
                  #elementRef
                  [cdkMenuItemDisabled]="(item | asDropdownHelpTextItem).isHelpText"
                  [class.dropdown-menu__item--danger]="item.isDanger"
                  [class.dropdown-menu__item--selected]="item.isSelected"
                  [class.dropdown-menu__item--helptext]="(item | asDropdownHelpTextItem).isHelpText"
                  [class.bold]="item.isBold"
                  [cdkMenuTriggerFor]="dropdownMenuRendererTpl.templateRef"
                  (click)="trigger === DropdownTrigger_Context && $event.preventDefault()"
                  (cdkMenuItemTriggered)="handleItemClick(item)"
                  class="dropdown-menu__item"
                  cdkMenuItem
                >
                  <ng-container *ngTemplateOutlet="actionButtonContentTpl; context: { $implicit: item }"></ng-container>
                </a>
              </ng-container>
              <ng-template #actionItemTpl>
                <a
                  #elementRef
                  [cdkMenuItemDisabled]="(item | asDropdownHelpTextItem).isHelpText"
                  [class.dropdown-menu__item--danger]="item.isDanger"
                  [class.dropdown-menu__item--selected]="item.isSelected"
                  [class.dropdown-menu__item--helptext]="(item | asDropdownHelpTextItem).isHelpText"
                  [class.bold]="item.isBold"
                  (click)="trigger === DropdownTrigger_Context && $event.preventDefault()"
                  (keydown.enter)="$event.stopPropagation(); elementRef.click()"
                  (cdkMenuItemTriggered)="handleItemClick(item)"
                  class="dropdown-menu__item"
                  cdkMenuItem
                >
                  <ng-container *ngTemplateOutlet="actionButtonContentTpl; context: { $implicit: item }"></ng-container>
                </a>
              </ng-template>
            </ng-template>
          </ng-template>
          <ng-template #anchorItemTpl>
            <a
              [routerLink]="item | asDropdownRouterLinkItem | dropdownMenuItemRouterLink"
              [queryParams]="(item | asDropdownRouterLinkItem).queryParams ?? undefined"
              [fragment]="(item | asDropdownRouterLinkItem).routerLinkFragment ?? undefined"
              [class.dropdown-menu__item--danger]="item.isDanger"
              [class.dropdown-menu__item--selected]="item.isSelected"
              [class.bold]="item.isBold"
              (click)="trigger === DropdownTrigger_Context && $event.preventDefault()"
              class="dropdown-menu__item"
              cdkMenuItem
            >
              <div class="flex items-center">
                <span>{{ item.title }}</span>
                <loop-icon *ngIf="item.icon" [name]="item.icon" height="14px" width="14px" />
              </div>
            </a>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-template #actionButtonContentTpl let-item>
    <div class="flex gap-x-half items-center">
      @if (item.icon) {
        <div>
          <loop-icon [name]="item.icon" height="14px" width="14px"></loop-icon>
        </div>
      }
      <div class="flex items-center justify-between gap-x flex-1">
        <span>{{ item.title }}</span>
        <ng-container *ngIf="item | isDropdownNestedItem; else shortcutTpl">
          <div>
            <loop-icon class="rotate-90 m-0" name="angle-up" height="14px" width="14px"></loop-icon>
          </div>
        </ng-container>
        <ng-template #shortcutTpl>
          <span class="shortcut" *ngIf="item.shortcut"> {{ item.shortcut }} </span>
        </ng-template>
      </div>
      @if (item.isSelected) {
        <loop-icon class="m-0" name="check" height="14px" width="14px"></loop-icon>
      }
    </div>
  </ng-template>
</ng-template>
